export default {"src":"https://fishbrain.com/_next/static/media/virginia.3c7447f7.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};